// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PrivacyDialogsFastTrackService } from '@client/app/modules/data-privacy/dialogs/fast-track/fast-track-service/fast-track.service';
import { DataPrivacyEntitiesFastTrackService } from '@client/app/modules/data-privacy/services/entities/fast-track.service';
import { DataPrivacyContentRepoService } from '@client/app/modules/data-privacy/services/api/content-repo/data-privacy-content-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonPromptService } from '@monsido/angular-shared-components';
import {
    PrivacyDialogsHelpCenterComponent,
} from '@client/app/modules/data-privacy/dialogs/help-center/help-center.component';
import {
    PrivacyViolationPagesComponent,
} from '@client/app/modules/data-privacy/dialogs/violation-pages/privacy-violation-pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'privacy-dialogs-fast-track',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'FASTTRACK'] | monIcons"
                         [header]="'Data Privacy Fast Track' | translate"
                         [subHeader]="'With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go' | translate">
            </page-header>
        </div>

        <div class="mon-dialog-body auto-scroll data-privacy-fast-track data-privacy">
            <div class="row max-height">
                <div class="col-lg-22 pr-lg-0 max-height bg-white border-r border-grey border-size-1 ft-table-container pt-4">
                    <table-container-pager [noResultMessage]="'Good job! No issues were found' | translate"
                                           [collection]="contents"
                                           [page]="page"
                                           [pageSize]="pageSize"
                                           (onPageChange)="onPageChange($event)"
                                           (onPerPageChange)="onPageSizeChange($event)"
                                           [progress]="progress">
                        <fast-track-table [snippets]="contents"
                                          [activeSnippet]="activeContent"
                                          (setActiveSnippet)="setActiveContent($event)">
                        </fast-track-table>
                    </table-container-pager>
                </div>
                <div class="col-lg-26 pl-lg-0 bg-light-grey max-height">
                    <div class="max-height scroll-y px-3" *ngIf="hasContent()">
                        <mon-spinner [loading]="loadingInfoTypes">
                            <fast-track-information [affectedPagesCount]="affectedPagesCount"
                                                    [chartData]="chartData"
                                                    [snippet]="activeContent">
                            </fast-track-information>
                            <div class="card panel-monsido-card" *ngIf="infoTypes.length > 0">
                                <div class="card-body py-3">
                                    <table class="table table-fixed table-hover remove-table-header-bottom-border checks-table">
                                        <thead>
                                        <tr>
                                            <th class="col-sm-3"><span class="sr-only" translate>Data Privacy Info Type Icon</span></th>
                                            <th class="col-sm-13" translate>Check</th>
                                            <th class="col-sm-8 text-right" translate>Help Center</th>
                                            <th class="col-sm-8 text-right" translate>Pages</th>
                                            <th class="col-sm-8 text-right" translate>Severity</th>
                                            <th class="col-sm-8 text-right" translate>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngFor="let infoType of infoTypes">
                                            <td class="text-v-middle">
                                                <mon-data-privacy-info-type-icon [monGroup]="infoType.group"
                                                                                 [monPriority]="infoType.priority"
                                                                                 [monTooltipText]="getInfoTypeTranslation(infoType) | translate">
                                                </mon-data-privacy-info-type-icon>
                                            </td>
                                            <td class="text-v-middle text-ellipsis">
                                                {{infoType.name}}
                                            </td>
                                            <td class="text-right text-v-middle">
                                                <button type="button"
                                                        class="btn btn-border-radius btn-link py-0 pr-0 pl-2"
                                                        (click)="openHelpCenter(infoType)">
                                                    <span class="fas fa-graduation-cap" aria-hidden="true"></span>
                                                    <span class="sr-only" translate>Open help center</span>
                                                </button>
                                            </td>
                                            <td class="text-right text-v-middle">
                                                <pages-button (callback)="openPages(infoType)" [ngModel]="infoType.pages_count">
                                                </pages-button>
                                            </td>
                                            <td class="text-right text-v-middle">
                                                <mon-data-privacy-severity-level [monPriority]="infoType.priority"></mon-data-privacy-severity-level>
                                            </td>
                                            <td class="text-right text-v-middle">
                                                <mon-action-menu [monActionMenuItems]="infoType.dropdown">
                                                    <span translate>Action</span>
                                                </mon-action-menu>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <h3 class="pt-10 text-center text-grey font-weight-300"
                                *ngIf="infoTypes.length === 0"
                                translate>
                                There are no more errors for this Snippet
                            </h3>
                        </mon-spinner>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PrivacyDialogsFastTrackComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    contents: any = [];
    activeContent: any = null;
    loadingInfoTypes: boolean = false;
    chartData: any = [0, 1];
    progress: any = null;
    affectedPagesCount: any;
    infoTypes: any = [];

    constructor (
        private monEventService: MonEventService,
        private privacyDialogsFastTrackService: PrivacyDialogsFastTrackService,
        private dataPrivacyEntitiesFastTrackService: DataPrivacyEntitiesFastTrackService,
        private dataPrivacyContentRepoService: DataPrivacyContentRepoService,
        private translateService: TranslateService,
        private monPromptService: MonPromptService,
    ) {
        super({ table: true });
    }

    ngOnDestroy (): void {
        this.privacyDialogsFastTrackService.clear();
    }

    hasContent (): boolean {
        return this.activeContent != null;
    }

    setActiveContent (event: any): void {
        this.activeContent = event.snippet || event;
        this.getInfoTypes();
    }

    getInfoTypeTranslation (infoType: any): string {
        return this.privacyDialogsFastTrackService.getInfoTypeTranslation(infoType);
    }

    openHelpCenter (infoType: any): void {
        const params = {
            size: 'lg',
            body: PrivacyDialogsHelpCenterComponent,
            data: {
                infoType: infoType,
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    openPages (infoType: any): void {
        const params = {
            size: 'lg',
            body: PrivacyViolationPagesComponent,
            data: {
                infoType: infoType,
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    updateInfoType (infoType: any): void {
        const content = this.activeContent;

        this.monPromptService.prompt(infoType.name, {
            parentSelector: '#common-dialog-wrapper',
            size: 'md',
            message: this.translateService.getString('Add reason (Optional)'),
        }).then((promptAnswer: any) => {
            this.loadingInfoTypes = true;
            const copy = safeClone(infoType);
            copy.comment = promptAnswer;
            this.progress = this.dataPrivacyEntitiesFastTrackService.updateInfoType(content.id, copy).then(
                () => {
                    if (this.activeContent.id === content.id) {
                        this.getPage();
                        return this.progress;
                    }
                    this.loadingInfoTypes = false;
                },
                () => {
                    this.loadingInfoTypes = false;
                },
            );
        }, () => {});
    }

    override getPage = (): void => {
        const params = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: 'effect_on_compliance',
            sort_dir: 'desc',
        };

        this.progress = this.dataPrivacyContentRepoService.getAll(params).then((contents: any) => {
            if (!this.hasContent() && contents.length > 0) {
                this.setActiveContent(contents[0]);
            } else if (contents.length > 0) {
                let index = contents.findIndex((item: any) => item.id === this.activeContent.id);
                if (index === -1) {
                    index = 0;
                }
                this.setActiveContent(contents[index]);
            }
            this.contents = contents;
        }, () => {});
    };

    ngOnInit (): void {
        this.monEventService.run('openFasttrack');
        this.privacyDialogsFastTrackService.setupSession();
        this.progress = null;
        this.activeContent = null;
        this.loadingInfoTypes = false;
        this.chartData = [0, 1];
        this.contents = [];
        this.getPage();
    }

    private getInfoTypes (): void {
        if (!this.hasContent()) {
            this.infoTypes = [];
            return;
        }
        const content = this.activeContent;
        this.loadingInfoTypes = true;
        this.dataPrivacyEntitiesFastTrackService.getInfoTypes(content.id)
            .then(
                (infoTypes: any) => {
                    this.infoTypes = infoTypes;
                    if (content && content.setIssueCount) {
                        content.setIssueCount(this.infoTypes);
                    }
                    this.updateDropdowns();
                },
                () => {
                    this.infoTypes = [];
                },
            )
            .finally(() => {
                this.loadingInfoTypes = false;
                this.affectedPagesCount = this.privacyDialogsFastTrackService.getAffectedPagesCount(this.infoTypes);
                const crawledPages = this.sessionService.domain?.crawled_pages || 0;
                this.chartData = [this.affectedPagesCount, crawledPages - this.affectedPagesCount];
            });
    }

    private updateDropdowns (): void {
        for (const infoType of this.infoTypes) {
            const dropdown = [
                {
                    label: this.translateService.getString('Review'),
                    leftIcon: 'faEye',
                    action: () => this.updateInfoType(infoType),
                },
            ];

            infoType.dropdown = dropdown;
        }
    }
}
